import { render } from "./MsCombobox.vue?vue&type=template&id=4f99b4fa&scoped=true"
import script from "./MsCombobox.vue?vue&type=script&lang=js"
export * from "./MsCombobox.vue?vue&type=script&lang=js"

import "./MsCombobox.vue?vue&type=style&index=0&id=4f99b4fa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f99b4fa"]])

export default __exports__